import { render, staticRenderFns } from "./UpcomingMotList.vue?vue&type=template&id=060c7e93&scoped=true"
import script from "./UpcomingMotList.vue?vue&type=script&lang=js"
export * from "./UpcomingMotList.vue?vue&type=script&lang=js"
import style0 from "./UpcomingMotList.vue?vue&type=style&index=0&id=060c7e93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c7e93",
  null
  
)

export default component.exports